import React from "react";
import Image from "next/image";
import Link from "next/link";
const data = [
  // {
  //   id: "1",
  //   icon: "/images/icons/mobile.svg",
  //   value: "+919599121499",
  //   href: "tel:+919599121499",
  // },
  {
    id: "2",
    icon: "/images/icons/mobile.svg",
    value: "+919599197669",
    href: "tel:+919599197669",
  },
  {
    id: "3",
    icon: "/images/icons/email.svg",
    value: "sales@chalkstudio.design",
    href: "mailto:sales@chalkstudio.design",
  },
  {
    id: "4",
    icon: "/images/icons/location.svg",
    value:
      "2001, T4, DLF Corporate greens, Sector 74A, Gurugram, Haryana 122004",
    href: "https://maps.app.goo.gl/D7Y9HMwvz94fEPSK9",
  },
  
];
export default function Card() {
  return (
    <div className="w-full flex flex-col lg:mt-8 mb-8 gap-4">
      <h1 className="text-darkGrey uppercase font-havletica font-light lg:text-[40px] md:text-[36px] text-[28px] leading-tight">
        Get in Touch with Chalk Studio’s Expert Interior Design Team to Begin Transforming Your Dream Spaces Into Reality
      </h1>
      <p>Get in Touch with Chalk Studio’s Expert Interior Design Team to Begin Transforming Your Dream Spaces Into Reality. Get in touch with our experts to begin your design journey. Contact us today to transform your space into something extraordinary.</p>
      <div className="flex lg:flex-row flex-col border-t-[0.5px] border-darkGrey/50 border-b-[0.5px] lg:justify-between lg:items-center gap-4 py-5">
        {data.map((e) => (
          <Link
            href={e.href}
            target="_blank"
            rel="noreferrer"
            key={e.id}
            className="flex items-center gap-3 text-sm md:text-base text-darkGrey/70 hover:underline transition-all duration-300 ease"
          >
            {e.icon && (<div className="relative w-9 h-9 shrink-0">
              <Image
                src={e.icon}
                alt="icon"
                fill
                className="object-center object-contain"
                sizes="(max-width: 479px) 100px, 100px"
              />
            </div>)}
            <span className="lg:max-w-[350px]">{e.value}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
